import React from "react";
import { useTranslation } from "react-i18next";

import getStyled from "../../hooks/getStyled";
import SFTypography from "../typography";
import { SFGridContainer, SFGridItem } from "../grid";
import { SFDownloadIcon } from "../icons";
import SFAsyncActionButton from "../button/asyncActionButton";

const { styled } = getStyled();

const StyledWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  backgroundColor: theme.palette.grey100.main,
  border: `1px solid ${theme.palette.grey250.main}`,
  borderRadius: 4,
  padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`,
}));

const SFDownloadFileCard = ({ icon, header, handleDownload }) => {
  const { t } = useTranslation();
  return (
    <StyledWrapper>
      <SFGridContainer spacing={1.5} alignItems="center">
        <SFGridItem xs="auto">{icon}</SFGridItem>
        <SFGridItem xs>
          <SFTypography variant="body1">{header}</SFTypography>
        </SFGridItem>
        <SFGridItem xs="auto">
          <SFAsyncActionButton
            variant="utility"
            onClick={handleDownload}
            endIcon={<SFDownloadIcon color="grey500" />}
          >
            {t("components.downloadFileCard.downloadButton")}
          </SFAsyncActionButton>
        </SFGridItem>
      </SFGridContainer>
    </StyledWrapper>
  );
};

export default SFDownloadFileCard;
